import { Segment } from 'semantic-ui-react';
import InsightCard from './InsightCard';
import { FunctionComponent } from 'react';
import { Company, Plan, ResourcesUsage } from '../../../types';
import { useLocale } from '../../../hooks';

type Props = {
    plan: Plan | undefined;
    company: Company | undefined;
    usageMonth: ResourcesUsage;
    loading?: boolean;
};

const UsageInsights: FunctionComponent<Props> = props => {
    const { loading, company, usageMonth, plan } = props;

    const labels = useLocale({
        sentMessages: 'Sent Messages',
        receivedMessages: 'Received Messages',
        menuOptions: 'Menu Options',
        messageTemplates: 'Message Templates',
    });

    if (!plan) return null;

    return (
        <Segment
            basic
            style={{
                padding: '0',
                display: 'flex',
                flexWrap: 'nowrap',
                justifyContent: 'space-between',
                gap: '8px',
                alignItems: 'center',
                border: 'none',
            }}
        >
            <InsightCard
                key='sent-messages-card'
                loading={loading}
                title={labels.sentMessages}
                value={String(usageMonth.messages_count.sent)}
                total={String(plan?.plan_company_messages_limit)}
            />
            <InsightCard
                key='received-messages-card'
                loading={loading}
                title={labels.receivedMessages}
                value={String(usageMonth.messages_count.received)}
                total={String(plan?.plan_user_messages_limit)}
            />
            <InsightCard
                key='menu-options-card'
                loading={loading}
                title={labels.menuOptions}
                value={String(usageMonth.menu_options_count)}
                total={String(plan?.plan_options_menu_limit + (company?.company_additional_menu_options || 0)) || ''}
            />
            <InsightCard
                key='message-templates-card'
                loading={loading}
                title={labels.messageTemplates}
                value={String(usageMonth.messages_templates_count)}
                total={String(plan?.plan_message_template_send_company)}
            />
        </Segment>
    );
};

export default UsageInsights;
